import React from 'react';
import PropTypes from 'prop-types';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// CardBody Component - showing name and metrics as text
const ProductionCardBody = ({ productionName, completionPercentage, tags, aaroFields }) => {
    // Function to determine color based on percentage

    return (
        <MDBox mt={1} display="flex" flexDirection="column">
            <MDTypography
                variant="caption"
                fontWeight="bold"
                sx={{ lineHeight: '1.3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
                {productionName}
            </MDTypography>
            <MDTypography
                variant="caption"
                fontWeight="text"
                textTransform="lowercase"
                sx={{ lineHeight: '1', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
                {aaroFields?.BelgeNo}
            </MDTypography>
            <MDBox display="flex" flexDirection="row" flexWrap="wrap" gap={0.5} mt={1}>
                {tags &&
                    tags.map((tag, index) => (
                        <MDBox
                            key={index}
                            display="inline-flex"
                            alignItems="center"
                            sx={{
                                borderRadius: '4px',
                                padding: '1px 4px',
                                border: `1px solid`,
                                borderColor: tag?.color || 'grey.300',
                            }}
                        >
                            <MDTypography variant="caption" fontWeight="regular" sx={{ fontSize: '0.7rem' }}>
                                #{tag?.name}
                            </MDTypography>
                        </MDBox>
                    ))}
            </MDBox>

            <MDBox mt={1} mb={1} borderBottom="1px solid" borderColor="grey.300" width="100%" opacity={0.5} />
        </MDBox>
    );
};

ProductionCardBody.propTypes = {
    productionName: PropTypes.string.isRequired,
    completionPercentage: PropTypes.number,
    getProgressColor: PropTypes.func,
    aaroFields: PropTypes.object,
    tags: PropTypes.array,
};

ProductionCardBody.defaultProps = {
    completionPercentage: 0,
    getProgressColor: (value) => 'info',
    aaroFields: {},
    tags: [],
};

export default ProductionCardBody;
